module.exports = __webpack_public_path__ + "03_long_grey.f78afbad.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/03_long_grey.png
// module id = Nol4
// module chunks = 0